import { menuThirds } from 'constants/menus'
import AppointmentDurations from 'features/setting/defaults/appointment-durations/appointment-durations'
import AppointmentChannels from 'features/setting/defaults/appointment-channels/appointment-channels'
import TemplateText from 'features/setting/defaults/template-text/template-text'
import Keyword from 'features/setting/defaults/keyword/keyword'
import BreakTemplate from 'features/setting/break-management/break-template'

const routeDefaults = [
  {
    ...menuThirds.APPOINTMENT_DURATION,
    component: AppointmentDurations,
    appBar: true
  },
  {
    ...menuThirds.APPOINTMENT_CHANNEL,
    component: AppointmentChannels,
    appBar: true
  },
  {
    ...menuThirds.TEMPLATE_TEXT,
    component: TemplateText,
    appBar: true

  },
  {
    ...menuThirds.KEYWORD,
    component: Keyword,
    appBar: true
  },
  {
    ...menuThirds.BREAK_TEMPLATE,
    component: BreakTemplate,
    appBar: true
  }
]

export default routeDefaults
